import gql from 'graphql-tag';

export class FormInput {
  id: number;
  collectorId: number;
  materialId: number;
  contractNo: string;
  contractSignDate: string;
  contractExpDate: string;
  isActive: boolean;

  constructor() {
    this.id = undefined;
    this.collectorId = undefined;
    this.materialId = undefined;
    this.contractNo = undefined;
    this.contractSignDate = undefined;
    this.contractExpDate = undefined;
    this.isActive = undefined;
  }
}

export const gqlGetCollectorsMaterialsQuery = gql`
  query getCollectorsMaterials($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectorsMaterials(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        collectorId
        materialId
        material {
          id
          name
          notes
        }
        contractNo
        contractSignDate
        contractExpDate
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlΙnitializeCollectorsMaterials = gql`
  mutation initializeCollectorsMaterials {
    initializeCollectorsMaterials
  }
`;

export const gqlUpdateCollectorsMaterial = gql`
  mutation updateCollectorsMaterials($data: CollectorsMaterialInput) {
    updateCollectorsMaterial(data: $data) {
      id
    }
  }
`;
